<!-- NOTE: This page was created with many items that could be abstracted into their own components. This was done deliberately to make the code more readable and easier to follow. -->
<div class="push-to-group">
  <div class="top">
    <div class="index" *ngIf="currentScreen === 'index'">
      <span class="ktitle-tiny">Quick People Push</span>
      <span class="klabel-medium">Quickly push this course to specific people.</span>
      <div class="select-requirements">
        <div class="input-select-container">
          <app-select
            [label]="'Select which requirement to apply this course to*'"
            [options]="formattedCourseRequirements"
            value="{{this?.coursePushPackage?.requirement?.id}}"
            [placeholder]="'Select a requirement'"
            (selectedValue)="updateCoursePushPackageParameter($event, 'requirement')"
            class="selecter"
          ></app-select>
        </div>
      </div>
      <div class="select-users">
        <span class="klabel-medium label">Select User(s)</span>
        <div class="input-select-container">
          <input #userinput (change)="updateCoursePushPackageParameter($event, 'users')" class="users-input kinput kbody-medium input-select" type="text" placeholder="Type or select a user" list="usertargets">
          <datalist id="usertargets" class="datalist">
            <option class="kbody-medium" *ngFor="let user of users">{{ user.fullName }}</option>
          </datalist>
        </div>
        <span class="klabel-medium label" *ngIf="coursePushPackage?.users?.length > 0">Selected Users</span>
        <div class="chips">
          <app-chip
            class="outlined"
            (closeChip)="removeUser(user)"
            [closable]="true"
            *ngFor="let user of coursePushPackage.users"
            [text]="user.fullName"
            ></app-chip>
        </div>
      </div>
      <div class="send-message">
        <span class="klabel-medium label">Additional Notes For Email (optional)</span>
        <textarea [(ngModel)]="coursePushPackage.messageContent" rows="4" class="kinput msg-input"></textarea>
      </div>
    </div>

  </div>

  <app-loading-spinner *ngIf="isLoading" class="spinner"></app-loading-spinner>

  <div *ngIf="currentScreen === 'index' || currentScreen === 'complete'" class="nav-row">
    <app-button (click)="closeModal()" [text]="'Cancel'" [class]="'white'"></app-button>
    <app-button (click)="submitPush()" [text]="'Push Course'" [class]="'green'"></app-button>
  </div>
</div>
